export default __webpack_public_path__ + "static/media/atom-i-close-dark.45b78b3e.svg";